export default "__VITE_ASSET__DeJbRIvB__"